import { call, put, takeEvery, select } from "redux-saga/effects";
import { UserSetupConstants } from "../constants/userSetup.constants";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import {
    completeUserSetupSuccess,
    completeUserSetupFailure
} from "../actions/userSetup.actions";
import Query from "../utils/graphqlQueryBuilder";
import { push } from "react-router-redux";

export function* userSetupComplete() {
    yield takeEvery(
        UserSetupConstants.COMPLETE_USER_SETUP,
        doCompleteUserSetup
    );
}

function* doCompleteUserSetup({ payload }) {
    let skipIntroduction = false;
    if (payload) {
        skipIntroduction = payload.skipIntroduction;
    }
    try {
        const {
            post,
            languages
        } = yield select(({ userSetup: { post, languages } }) => ({
            post,
            languages
        }));

        const updateUserMutation = new Query("mutation").find(
            new Query("updateUser", {
                languages: languages.toJS()
            }).find({
                languages: ["isLearning", "language", "level"]
            })
        );

        yield call(doGraphQLQuery, updateUserMutation.toString());

        if (!skipIntroduction && post.body.trim()) {
            const createPostMutation = new Query("mutation").find(
                new Query("createPost", {
                    body: post.body.trim(),
                    language: post.language
                }).find("id")
            );

            yield call(doGraphQLQuery, createPostMutation.toString());
        }

        yield put(completeUserSetupSuccess({ languages }));
        yield put(push("/feed"));
    } catch (e) {
        yield call(handleFailure, e, completeUserSetupFailure);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/userSetup.saga.js